import {useEffect} from 'react';

const Modal = ({children, onClose}) => {
    useEffect(() => {
        if (!onClose) return;
        const handleKey = e => { if (e.key === 'Escape') onClose(); };
        document.addEventListener('keydown', handleKey);
        return () => document.removeEventListener('keydown', handleKey);
    }, [onClose]);

    return (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose?.()}>
            <div className="modal-box">{children}</div>
        </div>
    );
};

export default Modal;
